<template>	
  <div v-show="this.filteredTableData.length">
    <vs-collapse class="suggestion-collapse">
      <vs-collapse-item open>
        <div slot="header">Currently Active MIS</div>
        <div class="form-actions">
          <span class="br-line mr-5 ml-5"></span>
          <vx-tooltip text="Duplicate MIS" position="top">
            <vs-button
              class="iconOnly"
              color="dark"
              type="flat"
              icon-pack="feather"
              icon="icon-copy"
              @click="copyMISData()"
              :disabled="this.selectedRowCount == 0"
            ></vs-button>
          </vx-tooltip>
        </div>
        <div>
          <div class="scrollable-area">
            <div id="ag-grid-demo" class="relatedPromo-screen">
              <div class="related-overly">
                <div id="grid-loader" class="grid-list vx-card vs-con-loading__container p-0">
                  <ag-grid-vue
                    id="autoHeightGrid"
                    :gridOptions="gridOptions"
                    class="ag-theme-material w-100 mb-4 ag-grid-table"
                    :columnDefs="columnDefs"
                    :defaultColDef="defaultColDef"
                    :rowData="filteredTableData"
                    components="components"
                    rowSelection="single"
                    :enableRangeSelection="true"
                    :suppressCopyRowsToClipboard="true"
                    colResizeDefault="shift"
                    :suppressDragLeaveHidesColumns="true"
                    :animateRows="true"
                    :floatingFilter="true"
                    :pagination="true"
                    :paginationPageSize="paginationPageSize"
                    :suppressPaginationPanel="true"
                    :suppressRowClickSelection="true"
                    :rowClassRules="rowClassRules"
                    :statusBar="statusBar"
                    :sideBar="sideBar"
                    :rowHeight="38"
                    :headerHeight="30"
                    :floatingFiltersHeight="40"
                    :checkboxSelection="true"
                    :domLayout="domLayout"
                    @row-selected="onRowSelected"
                    @column-resized="onColumnResized">
                  </ag-grid-vue>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vs-collapse-item>
    </vs-collapse> 
  </div>	
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";

import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import "@/assets/scss/radix/extraComponents/agGridStyleOverride.scss";

import CellRendererMISSuggestionsActions from "@/components/ag-grid-tables/actions/CellRendererMISSuggestionsActions.vue";
import CellRendererStatus from '@/components/ag-grid-tables/actions/CellRendererStatus.vue'

export default {
  name: "MISSuggestions",
  components: {
    AgGridVue,
    CellRendererMISSuggestionsActions,
    CellRendererStatus
  },
  props: {
    client: {
      type: [Object, Array]
    },
    tld: {
      type: [Object, Array]
      // type: Array,
      // default: []
    },
    type: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedRowCount:'',
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        suppressMovable: false,
        filter: false
      },
      rowClassRules: null,
      statusBar: null,
      sideBar: null,
      rowSelection: null,
      domLayout:null,
      columnDefs: [
        {
          headerName: "Client Name",
          field: "new_reseller.name",
          filter: "agSetColumnFilter",
          minWidth: 185,
          pinned:"left",
          checkboxSelection: true,
        },   
        {
          headerName: "TLD",
          field: "tld.tld_name",
          filter: "agSetColumnFilter",
          minWidth: 115,
          pinned:"left",
          // width: 100
        },    
        {
          headerName: "Type",
          field: "type",
          filter: "agTextColumnFilter",
          minWidth: 100,
          pinned:"left",
        }, 
        {
          headerName: "Period",
          field: "period",
          filter: "agTextColumnFilter",
          minWidth: 100,
          pinned:"left",
        },  
        {
          headerName: "Effective 1Yr Price",
          field: "effective_first",
          // filter: "agSetColumnFilter",
          minWidth: 150,
          cellRenderer: (data) => {
            // console.log('data', data.data);
            // this.number();
            if(data.data.type.includes('premium')) {
              return '<div>'+ data.data.effective_first_per +'%</div>';
            }
            else {
              return '<div>$'+ data.data.effective_first +'</div>';
            }
          },
        },
        {
          headerName: "Effective Multi-Yr Price",
          field: "effective_multi",
          // filter: "agSetColumnFilter",
          minWidth: 150,
          cellRenderer: (data) => {
            // this.number();
            if(data.data.type.includes('premium')) {
              return '<div>'+ data.data.effective_multi_per +'%</div>';
            }
            else {
              return '<div>$'+ data.data.effective_multi +'</div>';
            }
          },
        },
        {
          headerName: "Start Date",
          field: "start_date",
          filter: "agDateColumnFilter",
          minWidth: 175,
          filterParams: {
            comparator: function (filterLocalDateAtMidnight, cellValue) {
              let dateAsString = cellValue;
              if (dateAsString == null) return -1;
              let dateParts = dateAsString.split('-');
              let cellDate = new Date(
                Number(dateParts[0]),
                Number(dateParts[1]) - 1,
                Number(dateParts[2])
              );
              if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
              }
              if (cellDate < filterLocalDateAtMidnight) {
                return -1;
              }
              if (cellDate > filterLocalDateAtMidnight) {
                return 1;
              }
            },
            browserDatePicker: true,
          }
        },
        {
          headerName: "End Date",
          field: "end_date",
          filter: "agDateColumnFilter",
          minWidth: 175,
          filterParams: {
            comparator: function (filterLocalDateAtMidnight, cellValue) {
              let dateAsString = cellValue;
              if (dateAsString == null) return -1;
              let dateParts = dateAsString.split('-');
              let cellDate = new Date(
                Number(dateParts[0]),
                Number(dateParts[1]) - 1,
                Number(dateParts[2])
              );
              if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
              }
              if (cellDate < filterLocalDateAtMidnight) {
                return -1;
              }
              if (cellDate > filterLocalDateAtMidnight) {
                return 1;
              }
            },
            browserDatePicker: true,
          }
        }, 
        {
          headerName: "List Based",
          field: "list_based",
          filter: "agSetColumnFilter",
          minWidth: 120,
          // hide:true
        },
        {
          headerName: "Status",
          field: "status",
          filter: "agSetColumnFilter",
          minWidth: 120,
          cellRenderer: (data) => {
          // console.log('data', data.data.status);
          return  '<div class="badge badge--success inline">Active</div>'
          },
        },  
        {
          headerName: "AM",
          field: "am.name",
          filter: "agSetColumnFilter",
          minWidth: 120,
        }, 
      ],
      tableData: [],
      components: {
        CellRendererMISSuggestionsActions,
        CellRendererStatus
      }
    };
  },
  watch: {
    windowWidth(val) {
      // Toggle colummn movable
      this.toggleColumnMovable(val);
      // Toggle colummn pinning
      this.toggleColumnPinned(val);
    },

    client: {
      deep: true,
      handler() {
        this.populateTableData();
      },
    },
    tld: {
      deep: true,
      handler() {
        this.populateTableData();
      },
    },
    type: {
      deep: true,
      handler() {
        this.populateTableData();
      },
    },

    // filteredTableData(val){
    //   if(val.length == 0){
    //     // console.log('if');
    //     // var setFlag = false;
    //     this.$root.$emit('hideMISRelatedScreen', false);
    //   }else{
    //     // var setFlag = true;
    //     this.$root.$emit('hideMISRelatedScreen', true);
    //   }
    // }
  },
  computed: {
    windowWidth: function() {
      return this.$store.state.windowWidth;
    },
    paginationPageSize() {
      if (this.gridApi) {
        return this.gridApi.paginationGetPageSize();
      } else {
        return 500;
      }
    },
    totalPages() {
      if (this.gridApi) {
        return this.gridApi.paginationGetTotalPages();
      } else {
        return 0;
      }
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    },

    formatedClient() {
      if (!this.client || (Array.isArray(this.client) && !this.client.length)) {
        return [];
      }

      if (Array.isArray(this.client)) {
        var ClientName = this.client.map(x => {
          return x.value;
        });
      } else {
        var ClientName = this.client.value !== undefined ? [this.client.value] : [];
      }
      return ClientName;
    },

    formatedTld() {
      if (!this.tld || !this.tld.length) {
        return [];
      }

      var tldName = this.tld.map(x => {
        return x.value;
      });
      return tldName;
    },

    formatedType() {
      if (!this.type || !this.type.length) {
        return [];
      }

      return this.type.map(x => String(x));
    },

    filteredTableData() {
      var filterclientData = this.tableData.filter(x =>
        this.formatedClient.includes(x.new_reseller_id)
      );

      var filterTldData = filterclientData.filter(x =>
        this.formatedTld.includes(x.tld.id)
      );

      if (filterTldData.length) {
        return filterTldData;
      } else {
        return filterclientData;
      }
    }
  },
  methods: {
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 0.8
      });
    },
    toggleColumnMovable(val) {
      if (val <= 576) {
        this.defaultColDef["suppressMovable"] = true;
      } else {
        this.defaultColDef["suppressMovable"] = false;
      }
    },
    toggleColumnPinned(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("domain", null);
      } else {
        this.gridOptions.columnApi.setColumnPinned("domain", "left");
      }
    },
    onColumnResized() {
      this.gridApi.resetRowHeights();
    },
    sizeColumnsToFit() {
      this.gridApi.sizeColumnsToFit();
    },

    refreshPage() {
			// this.$root.$emit('refreshPage');
      // Reset filters
      // this.gridApi.setFilterModel(null);
      // Reset selection
      this.gridApi.deselectAll();
      // Reset sort
      this.gridApi.setSortModel(null);      
      // Table Data AXIOS Call
      this.populateTableData();			
    },
    refreshPageWithFilters() {
      this.flags["selectedAll"] = false;
      // Reset filters
      this.gridApi.setFilterModel(null);
      // Reset selection
      this.gridApi.deselectAll();
      // Reset sort
      this.gridApi.setSortModel(null);
      // Table Data AXIOS Call
      this.populateTableData();
    },
    onRowSelected(event) {
      if(event.node.selected) {
        // Push to selectedPromos
        this.selectedRowCount = this.gridApi.getSelectedNodes().length;
      }
      else {
        // Remove from selectedPromos
        this.selectedRowCount = this.gridApi.getSelectedNodes().length;
      }
    },

    setAutoHeight() {
      this.gridApi.setDomLayout('autoHeight');
      // auto height will get the grid to fill the height of the contents,
      // so the grid div should have no height set, the height is dynamic.
      document.querySelector('#autoHeightGrid').style.height = '';
    },
    
    getRowsFromResponse(responseData) {
      if (Array.isArray(responseData)) {
        return responseData;
      }

      return responseData && Array.isArray(responseData.data)
        ? responseData.data
        : [];
    },

    populateTableData() {
      let self = this;

      if (!this.formatedClient.length) {
        this.tableData = [];
        return;
      }

      const params = {
        limit: 200,
        status: "active",
        reseller_id: this.formatedClient.join(","),
      };

      if (this.formatedTld.length) {
        params.tld_id = this.formatedTld.join(",");
      }

      if (this.formatedType.length) {
        params.type = this.formatedType.join(",");
      }

      /* Get table data for mis-records */

        this.$axiosSecure
        .get("/mis-records", { params })
        .then(response => {
          const rows = this.getRowsFromResponse(response.data);

          //Passing premium value
          for (var key in rows) {
            if (rows[key].list_based == 0) {
              rows[key].list_based = "No";
            } else {
              rows[key].list_based = "Yes";
            }
            if (rows[key].status == "approved") {
              rows[key].status = "active"
            }
          }

          this.tableData = rows.filter(x =>
            x['status'] == "active" || x['status'] == "approved"
          );
        })
        .catch(error => {
          // Error notification
          self.$vs.notify({
            color: "danger",
            title: "Something went wrong",
            text: "Please contact the server admin"
          });

          console.log(error);
        });

    },
    copyMISData(){
      // console.log('selected', this.gridApi.getSelectedNodes());
      var selectedRow = this.gridApi.getSelectedNodes().map(x=>x.data);
      this.$root.$emit('copyMIS', selectedRow);
    }
  },
  beforeMount() {
    // Table Data AXIOS Call
    this.populateTableData();

    // Reset movable columns on mobile
    this.toggleColumnMovable(this.windowWidth);

    // Set Grid sidebar
    this.sideBar = {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            suppressSideButtons: true,
            suppressColumnSelectAll: true,
            suppressColumnExpandAll: true
          }
        }
      ]
    };
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    //set Auto height
    this.setAutoHeight();

    // Resize to fit columns
    this.sizeColumnsToFit();

    // Reset pinned columns on mobile
    this.toggleColumnPinned(this.windowWidth);

    this.$root.$on("duplicateMISRecord", rowData => {
      // console.log('rowData');
      this.$emit("duplicate-suggested-mis", rowData.data);
    });
    
    this.$root.$on("tableRefresh", () => {
      // console.log('refresh');
      this.refreshPage();
    });

    let self = this;
  },
  destroyed() {
    // Clear Listing Count
    this.$store.dispatch("clearListingCount");

    // Unbind Button Event Listeners
    this.$root.$off("duplicateMISRecord");
    this.$root.$off("tableRefresh");

  }
};
</script>

